<div class="matches">
  <div class="square" [ngClass]="{'win': m.state === 'G', 'lost': m.state === 'P'}" *ngFor="let m of matches">
    <ion-icon *ngIf="m.state === ''" name="play"></ion-icon>
    <label *ngIf="m.state !== ''">{{ m.state }}</label>
  </div>
</div>